// mds-dojo — dijit/_editor/plugins/TabIndent — FAITHFUL port of
// references/dijit/_editor/plugins/TabIndent.js. Lets tab / shift-tab indent / outdent
// list items instead of moving toolbar focus. Registers itself into _Plugin.registry.
//
// ADAPTATIONS: import paths repathed; `dojo/_base/declare` → declare-runtime;
//   `kernel.experimental` shimmed to a no-op when the slim mds kernel lacks it.
import declare from '../../../dojo/_base/declare-runtime'; // declare
import kernel from '../../../dojo/_base/kernel'; // kernel.experimental
import _Plugin from '../_Plugin';
import ToggleButton from '../../form/ToggleButton';

var experimental: any = (kernel as any).experimental || function () { /* no-op shim */ };

// module:
//		dijit/_editor/plugins/TabIndent

experimental("dijit._editor.plugins.TabIndent");


var TabIndent: any = declare("dijit._editor.plugins.TabIndent", _Plugin, {
	// summary:
	//		This plugin is used to allow the use of the tab and shift-tab keys
	//		to indent/outdent list items.  This overrides the default behavior
	//		of moving focus from/to the toolbar

	// Override _Plugin.useDefaultCommand... processing is handled by this plugin, not by dijit/Editor.
	useDefaultCommand: false,

	// Override _Plugin.buttonClass to use a ToggleButton for this plugin rather than a vanilla Button
	buttonClass: ToggleButton,

	command: "tabIndent",

	_initButton: function(){
		// Override _Plugin._initButton() to setup listener on button click
		this.inherited(arguments);

		var e = this.editor;
		this.own(this.button.on("change", function(val: any){
			e.set("isTabIndent", val);
		}));

		// Set initial checked state of button based on Editor.isTabIndent
		this.updateState();
	},

	updateState: function(){
		// Overrides _Plugin.updateState().
		// Ctrl-m in the editor will switch tabIndent mode on/off, so we need to react to that.
		var disabled = this.get("disabled");
		this.button.set("disabled", disabled);
		if(disabled){
			return;
		}
		this.button.set('checked', this.editor.isTabIndent, false);
	}
});

// Register this plugin.
_Plugin.registry["tabIndent"] = function(){
	return new TabIndent({command: "tabIndent"});
};


export default TabIndent;
